import { EnterpriseConfig } from "@app/config/AppConfig";
import Button from "@components/Atoms/Button/Button";
import Input from "@components/Atoms/Input";
import FormStyle from "@components/Form/FormStyle";
import ModalLayout from "@components/Layouts/Modal";
import ModalLayoutLight from "@components/Layouts/ModalLayoutLight";
import ModalToOpenService from "@core-ui/ContextServices/ModalToOpenService/ModalToOpenService";
import EnterpriseApi from "@ext/enterprise/EnterpriseApi";
import t from "@ext/localization/locale/translate";
import { useState } from "react";
import { formatGesUrl } from "../utils/formatGesUrl";

const EditEnterpriseConfig = ({ config, onSave }: { config: EnterpriseConfig; onSave: (gesUrl: string) => void }) => {
	const [value, setValue] = useState(config.gesUrl);
	const [disabled, setDisabled] = useState(false);

	return (
		<ModalLayout closeOnCmdEnter={false} isOpen onClose={() => ModalToOpenService.resetValue()}>
			<ModalLayoutLight>
				<FormStyle>
					<>
						<legend>{t("enterprise.ges-settings")}</legend>
						<fieldset>
							<div className="form-group">
								<div className="field field-string row" style={{ alignItems: "center" }}>
									<label className="control-label">{"GES URL"}</label>
									<div className="input-lable">
										<Input
											isCode
											onChange={async (e) => {
												setDisabled(true);
												const value = e.target.value;
												setValue(value);
												if (!value || value === "") return setDisabled(false);

												const gesUrl = formatGesUrl(value);
												setValue(gesUrl);
												setDisabled(!(await new EnterpriseApi(gesUrl).check()));
											}}
											value={value}
										/>
									</div>
								</div>
							</div>
						</fieldset>
						<div className="buttons">
							<Button disabled={disabled} onClick={() => onSave(value)}>
								{t("save")}
							</Button>
						</div>
					</>
				</FormStyle>
			</ModalLayoutLight>
		</ModalLayout>
	);
};

export default EditEnterpriseConfig;
